import { DocumentationItemHeaderV1, defaultDocumentationItemHeaderV1, } from "./item-header-v1";
import { z } from "zod";
export const DocumentationItemConfigurationV1 = z.object({
    showSidebar: z.boolean(),
    isPrivate: z.boolean().optional(),
    isHidden: z.boolean().optional(),
    header: DocumentationItemHeaderV1,
});
export const defaultDocumentationItemConfigurationV1 = {
    header: defaultDocumentationItemHeaderV1,
    showSidebar: true,
};
